import { BorderRadii } from './get-border-radius';

interface AdditionalPadding {
	left: number;
	right: number;
}

/**
 * Calculates the needed additional padding near corners with a border radius
 *
 * @param element element to read determine additional padding for
 */
export const getAdditionalPaddingFromBorderRadii = (borderRadii: BorderRadii): AdditionalPadding => {
	const maxBorderRadiusLeft = Math.max(borderRadii.topLeft, borderRadii.bottomLeft);
	const maxBorderRadiusRight = Math.max(borderRadii.topRight, borderRadii.bottomRight);

	return {
		left: getSingleAdditionalPadding(maxBorderRadiusLeft),
		right: getSingleAdditionalPadding(maxBorderRadiusRight),
	};
};

const getSingleAdditionalPadding = (borderRadius: number): number => {
	// Border radius threshold of 12px
	// Additional padding ratio of 50%
	return Math.max(0, 0.5 * (borderRadius - 12));
};
